export default __webpack_public_path__ + "static/media/flavorsBSC.805d62d5.svg";